import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import DialogContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";
import MeetingNotesContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/MeetingNotesContent";
import AbstractCommand from "../../../core/application/AbstractCommand";
import InternalStakeholdersModel from "../model/InternalStakeholdersModel";

export default class InternalStakeholderContentCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {InternalStakeholdersModel} internalStakeholdersModel 
     */
    constructor(dispatcher, internalStakeholdersModel) {
        super(dispatcher);

        this._internalStakeholdersModel = internalStakeholdersModel;
    }

    execute(evt) {
        const data = evt.params.data;
        /** @type {DialogContentComponent|MeetingNotesContent} */
        const content = data.content;
        const contentPlayer = data.contentPlayer;

        const stakeholderId = this._getInternalStakeholderIdForContent(content);
        this._internalStakeholdersModel.setContentForInternalStakeholderId(stakeholderId, content);

        contentPlayer.contentCompleted(content);
    }

    _getInternalStakeholderIdForContent(content) {
        switch (content.getType()) {
            case ContentTypes.TYPE_DIALOG:
                return content.getNpcID();
            case ContentTypes.TYPE_MEETING_NOTES:
                return content.getNotesTitle();

            default:
                console.error(`[InternalStakeholderContentCommand] Unhandled internal stakeholder content.`, content);
                return;
        }
    }
}